{
	"production": {
		"appId": "PXNsLC0Hv5",
		"jsSrc": "//client.px-cloud.net/PXNsLC0Hv5/main.min.js"
	},
	"staging": {
		"appId": "PX049dlI5h",
		"jsSrc": "//client.px-cloud.net/PX049dlI5h/main.min.js"
	},
	"demo": {
		"appId": "PX049dlI5h",
		"jsSrc": "//client.px-cloud.net/PX049dlI5h/main.min.js"
	},
	"development": {
		"appId": "PX049dlI5h",
		"jsSrc": "//client.px-cloud.net/PX049dlI5h/main.min.js"
	}
}
